import React from 'react';
import '../../../App.css';
import './Hero.css';
import HomepageSlider from "../HomepageSlider";


function Hero() {
    return (
        <div className='hero-container'>
            <HomepageSlider/>
            <div className='hero-btns'>
            </div>
        </div>
    );
}

export default Hero;
